import entityTypes, { EntityTypes } from '../constants/entityTypes';

const supportsTransactionFlow = (entityType: EntityTypes): boolean => (
  entityType === entityTypes.INDIVIDUAL
  || entityType === entityTypes.BUSINESS
  || entityType === entityTypes.ACCOUNT
);

export default supportsTransactionFlow;
